import { getWishlistHandles, buildProductCard } from './salon-product-card.js';

const MAX_DISPLAY = 48;

/**
 * Renders the shopper's saved wishlist into the grid, using the hidden
 * template card rendered server-side for an arbitrary real product. Re-runs
 * whenever the wishlist changes (e.g. the shopper un-hearts an item right
 * here) so the page always reflects localStorage without a reload.
 */
async function render() {
  const root = document.querySelector('[data-wishlist-products]');
  if (!root) return;

  const grid = root.querySelector('[data-wishlist-grid]');
  const emptyState = root.querySelector('[data-wishlist-empty]');
  const templateWrapper = root.querySelector('[data-testid="wishlist-card-template"]');
  const template = templateWrapper ? templateWrapper.querySelector('.salon-product-card') : null;

  const handles = getWishlistHandles().slice(0, MAX_DISPLAY);

  if (!grid) return;

  if (!handles.length) {
    grid.replaceChildren();
    if (emptyState) emptyState.hidden = false;
    return;
  }

  if (!template) {
    if (emptyState) emptyState.hidden = false;
    return;
  }

  if (emptyState) emptyState.hidden = true;

  const results = await Promise.allSettled(handles.map((handle) => buildProductCard(template, handle)));

  const cards = results
    .filter((result) => result.status === 'fulfilled' && result.value)
    .map((result) => /** @type {HTMLElement} */ (result.value));

  if (!cards.length) {
    grid.replaceChildren();
    if (emptyState) emptyState.hidden = false;
    return;
  }

  const fragment = document.createDocumentFragment();
  for (const card of cards) {
    const item = document.createElement('div');
    item.className = 'resource-list__item';
    item.appendChild(card);
    fragment.appendChild(item);
  }

  grid.replaceChildren(fragment);
}

document.addEventListener('salon:wishlist:update', render);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', render);
} else {
  render();
}
